import React, { useEffect, useRef, useState } from "react";
import { initHighchartsModules } from "../../../../../utils/initHighchartsModules";
import {
  Button,
  Card,
  Col,
  Dropdown,
  DropdownButton,
  Row,
} from "react-bootstrap";
import {
  fetchInvoiceActionData,
  fetchInvoiceReportsData,
} from "../../../../../services/BillingDashboardAPI";
import AccordionComponent from "../../../../../common/Accordion";

interface InvoiceActionDataProps {
  openDropdown: string | null;
  setOpenDropdown: React.Dispatch<React.SetStateAction<string | null>>;
  filters: {
    teamId: string | number | null;
    clientId: string | number | null;
    currencyType: string;
    yearMonth: Date | null;
  };
}

const InvoiceActionData: React.FC<InvoiceActionDataProps> = ({
  openDropdown,
  setOpenDropdown,
  filters,
}) => {
  const [summaryData, setSummaryData] = useState<any | null>(null);

  useEffect(() => {
    initHighchartsModules();
  }, []);

  const formatYearMonth = (date: Date | null) => {
    if (!date) return null;
    return date.toISOString().slice(0, 7); // YYYY-MM
  };

  const fetchLineItemPipelineData = async () => {
    try {
      const payload = {
        teamId: filters.teamId,
        clientId: filters.clientId,
        // currencyType: filters.currencyType,
        yearMonth: formatYearMonth(filters.yearMonth),
      };

      const result = await fetchInvoiceActionData(payload);
      setSummaryData(result?.result);
    } catch (error) {
      console.error("Failed to load case overview data", error);
    }
  };

  useEffect(() => {
    fetchLineItemPipelineData();
  }, [filters]);

  const [caseSummaryKey, setCaseSummaryKey] = useState<string | null>("0");

  const handleBodyAccordionSelect = (key: string | null) => {
    if (caseSummaryKey === key) {
      return;
    }
    setCaseSummaryKey(key || "0");
  };

  const summaryAccordion = (
    items: { title: JSX.Element; content: JSX.Element }[],
  ) => (
    <AccordionComponent
      items={items.map((item, index) => ({
        ...item,
      }))}
      activeKey={caseSummaryKey}
      onSelect={handleBodyAccordionSelect}
      isDashboard={true}
    />
  );

  const parsedData = summaryData?.[0]?.statusCounts
    ? JSON.parse(summaryData[0].statusCounts)
    : {};

  return (
    <>
      {summaryAccordion([
        {
          title: (
            <div className="d-flex justify-content-between align-items-center w-100 p-0">
              <span className="">Action Required</span>
            </div>
          ),
          content: (
            <div>
              <Row className="g-3 fade-in-left action_reqDbd customSpacing_word">
                <Col md={4}>
                  <Card
                    className="border-0  h-100"
                    style={{
                      cursor: "pointer",
                      backgroundColor: "#ffded9",
                      borderRadius: "8px",
                    }}
                  >
                    <Card.Body className="p-2">
                      <div className="d-flex justify-content-between align-items-center mb-2">
                        <span className="fw-bold cardTite_inf">On Hold</span>
                        <span
                          className="material-symbols-outlined first_bo first_bo2"
                          style={{ color: "#ee3036" }}
                        >
                          pause_circle
                        </span>
                      </div>

                      <h5 className="fw-bold mb-0" style={{ color: "#ee3036" }}>
                        {parsedData["On Hold"] || 0}
                      </h5>
                    </Card.Body>
                  </Card>
                </Col>

                {/* Closed Cases */}
                <Col md={4}>
                  <Card
                    className="border-0  h-100"
                    style={{
                      cursor: "pointer",
                      backgroundColor: "#ffd696",
                      borderRadius: "8px",
                    }}
                  >
                    <Card.Body className="p-2">
                      <div className="d-flex justify-content-between align-items-center mb-2 UICard">
                        <span className="fw-bold cardTite_inf">
                          Unbilled Invoices
                        </span>
                        <span
                          className="material-symbols-outlined first_bo first_bo4"
                          style={{ color: "#f29707" }}
                        >
                          receipt_long
                        </span>
                      </div>

                      <h5 className="fw-bold mb-0" style={{ color: "#f29707" }}>
                        {parsedData["Unbilled Invoices"] || 0}
                      </h5>
                    </Card.Body>
                  </Card>
                </Col>

                {/* Cancelled Cases */}
                <Col md={4}>
                  <Card
                    className="h-100 border-0"
                    style={{
                      cursor: "pointer",
                      backgroundColor: "#cffba2",
                      borderRadius: "8px",
                    }}
                  >
                    <Card.Body className="p-2">
                      {/* Header */}
                      <div className="d-flex justify-content-between align-items-center mb-2 ">
                        <span className="fw-bold cardTite_inf">
                          Billing Configuration
                        </span>

                        <span
                          className="material-symbols-outlined first_bo first_bo1"
                          style={{ color: "#abad46" }}
                        >
                          schedule
                        </span>
                      </div>

                      {/* New Two Sections */}
                      <div className="d-flex justify-content-between align-items-center">
                        {/* Expiring Soon */}
                        <div>
                          <div
                            className="fw-semibold"
                            style={{ fontSize: "12px" }}
                          >
                            Expiring Soon
                          </div>
                          <h6
                            className="fw-bold mb-0"
                            style={{ color: "#abad46" }}
                          >
                            {parsedData[
                              "Billing Configuration Expiring Soon"
                            ] || 0}
                          </h6>
                        </div>

                        {/* Divider */}
                        <div
                          style={{
                            borderLeft: "1px solid #999",
                            height: "30px",
                          }}
                        />

                        {/* Expired */}
                        <div className="text-end">
                          <div
                            className="fw-semibold"
                            style={{ fontSize: "12px" }}
                          >
                            Expired
                          </div>
                          <h6
                            className="fw-bold mb-0"
                            style={{ color: "#abad46" }}
                          >
                            {parsedData["Billing Configuration Expired"] || 0}
                          </h6>
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
              <Row className="g-3 fade-in-left mt-1 action_reqDbd customSpacing_word">
                <Col md={4}>
                  <Card
                    className="border-0 h-100"
                    style={{
                      cursor: "pointer",
                      backgroundColor: "#fdecbe",
                      borderRadius: "8px",
                    }}
                  >
                    <Card.Body className="p-2">
                      {/* Header */}

                      <div className="d-flex justify-content-between align-items-center mb-2 MCcard">
                        <span className="fw-bold cardTite_inf">
                          Missing Count
                        </span>
                        <span
                          className="material-symbols-outlined first_bo first_bo2"
                          style={{ color: "#9b6d15" }}
                        >
                          error_outline
                        </span>
                      </div>

                      {/* Two Column Section */}
                      <div className="d-flex">
                        {/* Pending */}
                        <div className="flex-fill pe-2 border_right_dashboardCase_history">
                          <div className="small text-muted mb-1">Page</div>
                          <h5
                            className="fw-bold mb-0 text-start"
                            style={{ color: "#169112" }}
                          >
                            {parsedData["Missing Count Page"] || 0}
                          </h5>
                        </div>

                        {/* Completed */}
                        <div className="flex-fill ps-3">
                          <div className="small text-muted mb-1">Line</div>
                          <h5
                            className="fw-bold mb-0 text-start"
                            style={{ color: "#0192d5" }}
                          >
                            {parsedData["Missing Count Line"] || 0}
                          </h5>
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>

                {/* Closed Cases */}
                <Col md={4}>
                  <Card
                    className="border-0  h-100"
                    style={{
                      cursor: "pointer",
                      backgroundColor: "#c6cdf7",
                      borderRadius: "8px",
                    }}
                  >
                    <Card.Body className="p-2">
                      <div className="d-flex justify-content-between align-items-center mb-2 NBCcard">
                        <span className="fw-bold cardTite_inf">
                          No Billing Configuration
                        </span>
                        <span
                          className="material-symbols-outlined first_bo first_bo2"
                          style={{ color: "#5667c9" }}
                        >
                          block
                        </span>
                      </div>

                      <h5 className="fw-bold mb-0" style={{ color: "#5667c9" }}>
                        {parsedData["No Billing Configuration"] || 0}
                      </h5>
                    </Card.Body>
                  </Card>
                </Col>

                {/* Cancelled Cases */}
                <Col md={4}>
                  <Card
                    className="border-0  h-100"
                    style={{
                      cursor: "pointer",
                      backgroundColor: "#e8c6f8",
                      borderRadius: "8px",
                    }}
                  >
                    <Card.Body className="p-2">
                      <div className="d-flex justify-content-between align-items-center mb-2 MBCcard">
                        <span className="fw-bold cardTite_inf">
                          Multiple Billing Configuration
                        </span>

                        <span
                          className="material-symbols-outlined first_bo first_bo3"
                          style={{ color: "#7f3a9d" }}
                        >
                          layers
                        </span>
                      </div>

                      <h5 className="fw-bold mb-0" style={{ color: "#7f3a9d" }}>
                        {parsedData["Multiple Billing Configuration"] || 0}
                      </h5>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </div>
          ),
        },
      ])}
    </>
  );
};

export default InvoiceActionData;
